import React, {Component} from "react";
import {Button, Divider, Form, Input, Layout, message, Modal, Pagination, Select, Table} from 'antd';

import Header from '../../components/header'
import Left from '../../components/leftAd'

import './caseAd.less'
import '../../assets/css/admin.less'
import {
    reqAddCase,
    reqAddQue,
    reqadminCase, reqCaseDetail,
    reqCategory,
    reqDeleteIllCase, reqDeleteIllQuestion, reqEditCase, reqEditQue, reqPaper,
    reqUpload
} from "../../api";
import '../../config/config'
import '../../api/index'
import Radio from "antd/es/radio";

const {Content} = Layout;
const {TextArea} = Input;
const {Option} = Select;

/**
 * 管理员案例题目路由组件
 */
class CaseForm extends Component {

    state = {
        category: [],
        imgId: '',
        cases: {},
        cid: 1
    };

    imgUpload = e => {
        document.getElementById("upload").click();
    };

    getForm1Value = () => {
        let flag = false;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                flag = true;
            }
        });
        if (flag) {
            const obj = this.props.form.getFieldsValue();
            obj["imgId"] = this.state.imgId;
            this.setState({
                imgId: ''
            });
            return (obj);
        }
    };

    handleUpload = async (e) => {
        e.persist();
        let file = e.target.files[0];   //选择的图片文件
        let data = new FormData();
        data.append('file', file);

        const result = await reqUpload(data);
        if (result.code === '000000') {
            this.setState({
                imgId: result.data
            });
            message.success("上传成功");
        } else {
            message.error(result.data.msg);
        }

    };

    onChange = (value) =>{
        sessionStorage.setItem("cid",value);
    };

    componentDidMount = async () => {
        const result = await reqCategory("CASE");
        if (result.code === '000000') {
            this.setState({
                category: result.data.rows
            })
        } else {
            message.error(result.msg);
        }
        let caseId = sessionStorage.getItem("caseId");
        let cid = sessionStorage.getItem("cid");
        if (caseId !== 'none') {
            const res = await reqCaseDetail(caseId);
            if (res.code === '000000') {
                if (res.data.imgs) {
                    this.setState({
                        imgId: res.data.imgs[0]
                    })
                }
                this.setState({
                    cases: res.data
                })
            } else {
                message.error(res.msg);
            }
        }
        this.setState({
            cid: cid - 0
        })
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {cases} = this.state;
        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 8},
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 16},
            },
        };
        return (
            <Form {...formItemLayout} className='caseAd'>
                {
                    cases &&
                    <Form.Item hidden>
                        {getFieldDecorator('id', {
                            initialValue: cases.id,
                        })(<Input hidden/>)}
                    </Form.Item>
                }
                <Form.Item label="分类">
                    {getFieldDecorator('cid', {
                        initialValue: this.state.cid,
                        rules: [
                            {
                                required: true,
                                message: '请选择分类!',
                            },
                        ],
                    })
                    (
                        <Select id='search_select'
                                style={{width: 200}} onChange={this.onChange}>
                            {
                                this.state.category&&this.state.category.map((item, index) => (
                                    <Option key={index} value={item.id}>{item.name}</Option>
                                ))
                            }
                        </Select>
                    )}
                </Form.Item>
                <Form.Item label="标题">
                    {getFieldDecorator('title', {
                        initialValue: cases.title,
                        rules: [
                            {
                                required: true,
                                message: '请输入标题!',
                            },
                        ],
                    })(<Input autoComplete="off"/>)}
                </Form.Item>
                <Form.Item label="封面">
                    <Input name="file" accept="image/*" id="upload" type="file"
                           onChange={this.handleUpload.bind(this)}/>
                    <button className='upload_div' onClick={this.imgUpload}>上传图片</button>
                </Form.Item>
                <Form.Item label="预览图">
                    {
                        this.state.imgId && (
                            <img className='upload'
                                 src={global.constant.uploadImage + this.state.imgId}/>
                        )
                    }
                </Form.Item>
                <Form.Item label="简介">
                    {getFieldDecorator('description', {
                        initialValue: cases.description,
                        rules: [
                            {
                                required: true,
                                message: '请输入简介!',
                            },
                        ],
                    })(<Input autoComplete="off"/>)}
                </Form.Item>
            </Form>
        )
    }
}

class QueForm extends Component {

    state = {
        que: {}
    };

    getForm2Value = () => {
        let flag = false;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                flag = true;
            }
        });
        if (flag) {
            const obj = this.props.form.getFieldsValue();
            return (obj);
        }
    };

    componentDidMount = async () => {
        let caseQId = sessionStorage.getItem("caseQId");
        let questionId = sessionStorage.getItem("questionId");
        if (questionId !== 'none') {
            const res = await reqCaseDetail(caseQId);
            if (res.code === '000000') {
                const arr = res.data.questions;
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].id === (questionId - 0)) {
                        let que = arr[i];
                        let options = '';
                        let opt = arr[i].options;
                        if (opt.length>0) {
                            for (let i = 0; i < opt.length; i++) {
                                options += opt[i].optionValue;
                                if (i < opt.length - 1) {
                                    options += "\n"
                                }
                            }
                            que["options"] = options;
                            this.setState({
                                que: que
                            });
                            break;
                        }
                    }
                }
            } else {
                message.error(res.msg);
            }
        }
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {que} = this.state;
        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 8},
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 16},
            },
        };
        return (
            <Form {...formItemLayout} className='caseAd'>
                {
                    que &&
                    <Form.Item hidden>
                        {getFieldDecorator('id', {
                            initialValue: que.id,
                        })(<Input hidden/>)}
                    </Form.Item>
                }
                <Form.Item label="问题">
                    {getFieldDecorator('question', {
                        initialValue: que.question,
                        rules: [
                            {
                                required: true,
                                message: '请输入问题!',
                            },
                        ],
                    })(<Input autoComplete="off" placeholder={'请输入问题'}/>)}
                </Form.Item>
                <Form.Item label="类型">
                    {getFieldDecorator('questionType', {
                        initialValue: que.questionType,
                        rules: [
                            {
                                required: true,
                                message: '请选择类型!',
                            },
                        ],
                    })(
                        <Radio.Group>
                            <Radio value={'A'}>A型</Radio>
                            <Radio value={'X'}>X型</Radio>
                        </Radio.Group>
                    )}
                </Form.Item>
                <Form.Item label="选项">
                    {getFieldDecorator('options', {
                        initialValue: que.options,
                        rules: [{required: true, message: '请输入选项!'}],
                    })(<TextArea rows={4} placeholder={'请输入选项，一行一个选项'} autoComplete="off"/>)}
                </Form.Item>
                <Form.Item label="答案">
                    {getFieldDecorator('correctAnswer', {
                        initialValue: que.answer,
                        rules: [
                            {
                                required: true,
                                message: '请输入答案!',
                            },
                        ],
                    })(<Input placeholder={'请输入答案(多个答案用|分开)'} autoComplete="off"/>)}
                </Form.Item>
            </Form>
        )
    }
}

const Form1 = Form.create()(CaseForm);
const Form2 = Form.create()(QueForm);
export default class CaseAd extends Component {

    state = {
        caseList: [],
        category: [],
        total: 0,
        page: 1,
        size: 10,
        visible: false,
        ModalText: '',
        imgId: '',
        cid: 1,
        cases: {},
        disable: false,
        QueText: '新增题目',
        qid: 0,
        deleteVisible: false,
        deleteCase: {},
        deleteId: '',
        deleteName: '',
        selectedRowKeys: [],
        selectValue: 0,
        cname: "望神色形态",
        caseQId: 0
    };

    backControl=(index)=> {
        let rows = document.getElementsByClassName("ant-table-row");
        for (let i = 0; i < rows.length; i++) {
            if(i ===index){
                document.getElementsByClassName("ant-table-row")[i].style.cssText="background-color: #CCEBFF;";
            }else{
                if((i+1)%2===0){
                    document.getElementsByClassName("ant-table-row")[i].style.cssText="background-color: #fff;";
                }else{
                    document.getElementsByClassName("ant-table-row")[i].style.cssText="background-color: #f0f0f0;";
                }
            }
        }
    };

    showDeleteModal = (record, type) => {
        if (type === '删除') {
            this.setState({
                deleteId: record.id,
                deleteName: record.title,
                deleteVisible: true
            })
        } else if (type === "批量删除") {
            if (this.state.deleteId === '') {
                message.info("没有选中行");
            } else {
                this.setState({
                    deleteVisible: true
                })
            }
        } else {
            this.setState({
                deleteId: record.id,
                deleteName: record.question,
                deleteVisible: true,
                deleteType: type,
            })
        }
    };

    deleteCase = async (ids, e) => {
        e.persist();
        let result = "";
        if (this.state.deleteType === '删除问题') {
            result = await reqDeleteIllQuestion(this.state.caseQId, this.state.deleteId);
        } else {
            result = await reqDeleteIllCase(ids);
        }
        if (result.code === '000000') {
            message.success("删除成功");
            this.getCaseList(this.state.cid, 1, 10);
            this.handleCancel();
        }
        sessionStorage.setItem("pIndex",0);
        sessionStorage.setItem("adId",0);
    };

    editCase = (record, e) => {
        e.persist();
        this.setState({
            visible: true,
            ModalText: '编辑',
            cases: record
        });
        sessionStorage.setItem("caseId", record.id);
        sessionStorage.setItem("cid", this.state.cid);
    };

    pageClick = async page => {
        sessionStorage.clear();
        window.scrollTo(0, 0);
        this.getCaseList(this.state.cid, page, 10);
    };

    onChange = (value) => {
        this.setState({
            cid: value
        })
    };

    itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>上一页</a>;
        }
        if (type === 'next') {
            return <a>下一页</a>;
        }
        return originalElement;
    };

    showTotal = (total) => {
        return '共' + total + '条记录/每页' + this.state.size + '条';
    };

    handleSubmit = async (event) => {
        //组织表单的默认行为
        event.preventDefault();
        const values = this.form1Ref.getForm1Value();
        if (values && values.title && values.description) {
            let data = {
                "title": values.title,
                "description": values.description,
                "imgs": [values.imgId]
            };
            let result = "";
            let mes = "";
            let cid = sessionStorage.getItem("cid");
            if (this.state.ModalText === '新增案例') {
                result = await reqAddCase(cid, data);
                /*let cname = document.getElementsByClassName("ant-select-selection-selected-value")[1].innerText;
                this.setState({
                    cname:cname
                });*/
                mes = "新增成功";
            } else {
                data["id"] = values.id;
                result = await reqEditCase(cid, data);
                mes = "编辑成功";
            }
            if (result.code === '000000') {
                let cname = "";
                sessionStorage.setItem("cid",cid);
                if(cid===1||cid==="1"){
                    cname="望神色形态";
                }else {
                    cname="望舌";
                }
                this.setState({
                    cid:cid,
                    cname:cname
                });
                document.getElementsByClassName("ant-select-selection-selected-value")[0].innerHTML = cname;
                this.getCaseList(cid, this.state.page, 10);
                this.handleCancel();
                message.success(mes);
            } else {
                message.error(result.data.msg);
            }
        }
    };

    handleCancel = () => {
        this.setState({
            visible: false,
            deleteVisible: false,
            deleteId: '',
            deleteName: '',
            imgId: '',
            disable: false,
            ModalText: '',
            selectedRowKeys: []
        });
    };

    queSubmit = async (event) => {
        //组织表单的默认行为
        event.preventDefault();
        //对所有表单字段进行校验
        const values = this.form2Ref.getForm2Value();
        if (values) {
            let optArr = values.options.split('\n');
            let option = [];
            for (let i = 0; i < optArr.length; i++) {
                option[i] = {"optionKey": String.fromCharCode(65 + i), "optionValue": optArr[i]};
            }
            let data = {
                question: values.question,
                options: option,
                correctAnswer: values.correctAnswer,
                questionType: values.questionType
            };
            let result = "";
            if (this.state.ModalText === '新增题目') {
                result = await reqAddQue(this.state.caseQId, data);
            }else {
                data["id"] =values.id;
                result = await reqEditQue(this.state.caseQId, data);
            }
            if (result.code === '000000') {
                this.getCaseList(this.state.cid, this.state.page, 10);
                message.success(this.state.ModalText+"成功");
                this.handleCancel();
            } else {
                message.error(result.data.msg);
            }
        }
    };

    showAddModal = () => {
        this.setState({
            visible: true,
            ModalText: '新增案例',
            cases: {},
            cid:sessionStorage.getItem("cid")
        });
        sessionStorage.setItem("caseId", "none");
    };

    getCategoryList = async (type) => {
        const result = await reqCategory(type);
        if (result.code === '000000') {
            this.setState({
                category: result.data.rows
            })
        } else {
            message.error(result.msg);
        }
    };

    getCaseList = async (cid, page, size) => {
        const result = await reqadminCase(cid, page, size);
        if (result.code === '000000') {
            this.setState({
                caseList: result.data.rows,
                page: result.data.page,
                total: result.data.total
            });
            if (result.data.total > 0) {
                let adId = sessionStorage.getItem("adId");
                if(adId&&adId!==""&&adId!=="0"){
                    this.getQList(adId);
                    let index = sessionStorage.getItem("pIndex")-0;
                    this.backControl(index);
                }else {
                    this.getQList(result.data.rows[0].id);
                    this.backControl(0);
                }
            }
        } else {
            message.error(result.data.msg);
        }
    };

    addQue = (record, e) => {
        this.setState({
            disable: true,
            cases: {},
            qid: record.id,
            ModalText: '新增题目'
        });
        sessionStorage.setItem("caseQId", this.state.caseQId);
        sessionStorage.setItem("questionId", "none");
    };

    searchList = async () => {
        let category = this.state.category;
        let cname = document.getElementsByClassName("ant-select-selection-selected-value")[0].innerText;
        let cid = 1;
        for (let i = 0; i < category.length; i++) {
            if(cname===category[i].name){
                cid = category[i].id
            }
        }
        this.setState({
            cname: cname,
            cid:cid
        });
        sessionStorage.setItem("cid",cid);
        this.getCaseList(cid, 1, 10);
    };

    getQList = async (id) => {
        const result = await reqCaseDetail(id);
        if (result.code === '000000') {
            this.setState({
                QList: result.data.questions,
                caseQId: id
            })
        }
    };

    queList = async (record,index) => {
        sessionStorage.setItem("pIndex",index);
        sessionStorage.setItem("adId",record.id);
        this.backControl(index);
        this.getQList(record.id);
    };

    editQue = (object) => {
        sessionStorage.setItem("caseQId", this.state.caseQId);
        sessionStorage.setItem("questionId", object.id);
        this.setState({
            disable: true,
            ModalText:"编辑"
        })
    };

    clearSearch = async () => {
        sessionStorage.clear();
        window.location.reload();
    };
    componentDidMount = async () => {
        sessionStorage.clear();
        sessionStorage.setItem("cid",1);
        window.scrollTo(0, 0);
        this.getCaseList(1, 1, 10);
        this.getCategoryList("CASE");
        document.getElementsByClassName("ant-menu-item")[10].click();
    };

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return state;
        }
    }

    render() {

        const {total, page, visible, confirmLoading, selectedRowKeys, size, deleteId, deleteName, ModalText, caseList, category, deleteVisible, deleteCase, QueText, disable} = this.state;

        const columns = [
            {
                title: '编号',
                dataIndex: 'id',
                key: 'id',
                render: (text, record,index) => (
                    <span>{(this.state.page-1)*this.state.size+index+1}</span>
                ),
            },
            {
                title: '所属分类',
                dataIndex: 'sort',
                key: 'sort',
                render: (text, record) => (
                    <span>{this.state.cname}</span>)
            },
            {
                title: '标题',
                dataIndex: 'title',
                key: 'title',
            },
            {
                title: '操作',
                key: 'action',
                render: (text, record) => (
                    <span>
                        <a onClick={this.addQue.bind(this, record)}>添加题目</a>
                        <Divider type="vertical"/>
                        <a onClick={this.editCase.bind(this, record)} style={{color: '#12c4ed'}}>编辑</a>
                        <Divider type="vertical"/>
                        <a onClick={this.showDeleteModal.bind(this, record, '删除')}>删除</a>
                    </span>
                ),
            },
        ];

        const columnQ = [
            {
                title: '问题',
                dataIndex: 'question',
                key: 'question',
            },
            {
                title: '操作',
                key: 'action',
                render: (text, object) => (
                    <span>
                        <a onClick={this.editQue.bind(this, object)}>编辑</a>
                        <Divider type="vertical"/>
                        <a style={{color: "#e20101"}} onClick={this.showDeleteModal.bind(this, object, '删除问题')}>删除</a>
                    </span>
                ),
            }
        ];

        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                let name = [];
                for (let i = 0; i < selectedRows.length; i++) {
                    name.push(selectedRows[i].title)
                }
                this.setState({
                    deleteId: selectedRowKeys.toString(),
                    deleteName: name.toString(),
                    selectedRowKeys: selectedRowKeys
                })
            },
            getCheckboxProps: record => ({
                disabled: record.title === 'Disabled User', // Column configuration not to be checked
                name: record.title,
            }),
        };

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <Left>Left</Left>
                    <Content>
                        <div className={'tables'}>
                        <div className='table_right caseAdLeft'>
                            <div className='table_search'>
                                <Button className='batch_delete'
                                        onClick={this.showDeleteModal.bind(this, deleteId, '批量删除')}>批量删除</Button>
                                <Button className="add_class" onClick={this.showAddModal}>新增案例</Button>
                                <Button className='batch_delete clear' onClick={this.clearSearch}>重置</Button>
                                <Button className='batch_delete search' onClick={this.searchList}>检索</Button>
                                <div className='search_box'>
                                    <label>分类</label>
                                    <Select id='search_select'
                                            style={{width: 185}} defaultValue={1}
                                            onChange={this.onChange}>
                                        {
                                            category&&category.map((item, index) => (
                                                <Option key={index} value={item.id}>{item.name}</Option>
                                            ))
                                        }
                                    </Select>
                                </div>
                            </div>
                            <Table rowSelection={rowSelection} columns={columns} pagination={false}
                                   onRow={(record,index) => {
                                       return {
                                           onClick: this.queList.bind(this, record,index)
                                       }// 点击行
                                   }}
                                   dataSource={caseList} rowKey={caseList => caseList.id}/>
                            <Pagination total={total} current={page} pageSize={size} onChange={this.pageClick}
                                        itemRender={this.itemRender} showTotal={this.showTotal}/>
                        </div>
                        <div className='check_right'>
                            <Table columns={columnQ} pagination={false} dataSource={this.state.QList}
                                   rowKey={QList => QList.id}/>
                        </div>
                        </div>
                        <Modal title={ModalText} visible={visible} onOk={this.handleSubmit}
                               confirmLoading={confirmLoading} onCancel={this.handleCancel}
                               okText="确认" cancelText="取消" destroyOnClose='true'>
                            <Form1 wrappedComponentRef={(form) => this.form1Ref = form}>Form1</Form1>
                        </Modal>
                        <Modal title={ModalText} visible={disable} onOk={this.queSubmit}
                               confirmLoading={confirmLoading} onCancel={this.handleCancel}
                               okText="确认" cancelText="取消" destroyOnClose='true'>
                            <Form2 wrappedComponentRef={(form) => this.form2Ref = form}>Form2</Form2>
                        </Modal>
                        <Modal
                            title="提示"
                            visible={deleteVisible}
                            okText={"确定"}
                            cancelText={"取消"}
                            onOk={this.deleteCase.bind(this, deleteId)}
                            onCancel={this.handleCancel}>
                            <div>确定删除吗？</div>
                        </Modal>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}